import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = ({
  disabled,
  dsf_resizable,
  dsf_error,
  dsf_success,
  dsf_size
}) => {
  const classes = [
    "relative",
    "w-full",
    "rounded-sm",
    "border",
    "flex",
    "flex-row",
    "p-12",
    "appearance-none",
    "outline-none"
  ];
  classes.push(dsf_size === "small" ? "dsf-text-xs" : "dsf-text-s");
  if (disabled) {
    classes.push("bg-neutral-50", "resize-none");
  } else {
    if (dsf_resizable) {
      classes.push("resize");
    } else {
      classes.push("resize-none");
    }
    classes.push("bg-neutral-0", "active:bg-secondary-50");
    if (dsf_error) {
      classes.push("border-error-300", "focus:shadow-focus-danger-md");
    } else if (dsf_success) {
      classes.push("border-success-300", "focus:shadow-focus-success-md");
    } else {
      classes.push(
        "focus:border-secondary-300",
        "focus:shadow-focus-secondary-md",
        "border-neutral-100"
      );
    }
  }
  return concatClasses(classes);
};
const getWrapperClasses = ({ disabled, dsf_size }) => {
  const classes = ["flex", "min-w-0", "flex-auto", "flex-col"];
  classes.push(dsf_size === "small" ? "dsf-text-xxs" : "dsf-text-xs");
  classes.push(dsf_size === "small" ? "gap-2" : "gap-4");
  if (disabled) {
    classes.push("text-neutral-200");
  }
  return concatClasses(classes);
};
const getMessageClasses = ({ disabled, dsf_success, dsf_error, dsf_size }) => {
  const classes = ["dsf-text-xxs"];
  classes.push(dsf_size === "small" ? "mt-2" : "mt-4");
  if (dsf_error) {
    classes.push("text-error-300");
  } else if (dsf_success) {
    classes.push("text-success-300");
  } else if (disabled) {
    classes.push("text-neutral-300");
  } else {
    classes.push("text-neutral-700");
  }
  return concatClasses(classes);
};
export {
  getClasses,
  getMessageClasses,
  getWrapperClasses
};
